// Central catalog for services supported by BuildBright project intake and contractor opportunity routing
export const CITIES = ["Los Angeles", "San Jose", "San Diego", "Anaheim"];

const SERVICES = [
  {
    slug: "roofing",
    icon: "🛠️",
    title: "Roofing Leads",
    blurb:
      "Exclusive homeowner inquiries for repairs & re-roofs. Calls and forms filtered by your ZIPs.",
    features: [
      "Exclusive or limited-share options",
      "Spam & duplicate filtering",
      "Call recording + form validation",
      "Geo-targeting by city/ZIP",
    ],
    cta: { label: "Get Roofing Leads", href: "/contact?service=roofing" },
  },
  {
    slug: "solar",
    icon: "☀️",
    title: "Solar Leads",
    blurb:
      "High-intent solar prospects asking for quotes. We route only in your coverage zones.",
    features: [
      "Homeowner intent checks",
      "Utility bill capture (optional)",
      "Real-time lead delivery (email/SMS/webhook)",
      "Appointment-ready options",
    ],
    cta: { label: "Get Solar Leads", href: "/contact?service=solar" },
  },
  {
    slug: "landscaping",
    icon: "🌿",
    title: "Landscaping Leads",
    blurb:
      "Homeowners requesting maintenance, clean-ups and installs. You set the service radius.",
    features: [
      "Job type & budget screening",
      "Duplicate suppression",
      "Instant notifications",
      "Multi-location routing",
    ],
    cta: {
      label: "Get Landscaping Leads",
      href: "/contact?service=landscaping",
    },
  },
  {
    slug: "hvac",
    icon: "❄️",
    title: "HVAC Leads",
    blurb:
      "Connect with homeowners needing AC repair, furnace installations, or regular maintenance.",
    features: [
      "Targeted local routing",
      "Real-time alerts",
      "Verified homeowner intent",
      "Custom service area",
    ],
    cta: {
      label: "Get HVAC Leads",
      href: "/contact?service=hvac",
    },
  },
  {
    slug: "plumbing",
    icon: "🚰",
    title: "Plumbing Leads",
    blurb:
      "Review relevant homeowner project opportunities for emergency drain cleaning, pipe repairs, or water heater replacements.",
    features: [
      "Emergency vs standard job tags",
      "Direct homeowner routing",
      "Call recording and validation",
      "Area-specific targeting",
    ],
    cta: {
      label: "Get Plumbing Leads",
      href: "/contact?service=plumbing",
    },
  },
  {
    slug: "electrical",
    icon: "⚡",
    title: "Electrical Leads",
    blurb:
      "Find local homeowners looking for panel upgrades, EV chargers, and other electrical work.",
    features: [
      "High-intent local leads",
      "Spam filtering",
      "Instant push notifications",
      "Flexible budget constraints",
    ],
    cta: {
      label: "Get Electrical Leads",
      href: "/contact?service=electrical",
    },
  },
];

export default SERVICES;
